export default __webpack_public_path__ + "static/media/cross.5dfb9174.svg";